"use strict";

import Vue from 'vue';
import axios from "axios";
import NProgress from 'nprogress';
import store from './store/';
import i18n from './i18n';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  baseURL: process.env.VUE_APP_REST_SERVER_URL
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(config => {
	// Do something before request is sent
	NProgress.start();
	return config;
}, error => {
	// Do something with request error
	NProgress.done();
	return Promise.reject(error);
});

// Add a response interceptor
_axios.interceptors.response.use(response => {
	// Do something with response data
	NProgress.done();
	return response;
}, error => {
	NProgress.done();
	// Do something with response error
	if (navigator.vibrate){
		navigator.vibrate([500]);
	}
	// store.dispatch('authError', {err: error});

	if (error.message === 'Network Error') {
		store.commit('authError');
		store.dispatch('setConnectionError', {connectionError: true});
		console.log('Network error');
		Vue.prototype.$snack.danger(i18n.t('network-error'));
	} else {
		let response = error.response;
		let resp = response.data.response;
		if (resp) {
			let cause = resp.cause;
			if (cause && cause === 'authentication') {
				store.commit('authLogout');
				console.log('Authentication error');
			}
		}
	}
	return Promise.reject(error);
});

Plugin.install = function(Vue, options) {
	Vue.axios = _axios;
	window.axios = _axios;
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return _axios;
			}
		},
		$axios: {
			get() {
				return _axios;
			}
		},
	});
};

Vue.use(Plugin)

export default Plugin;
